/**
 * this is the controller to handle actions and settings for the navigation
 **/
export default class NavigationController {
	/**
	 * define required services here
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		this.$rootRouter = $injector.get('$rootRouter');
		this.NavigationService = $injector.get('navigationService')
		this.$location = $injector.get('$location');
	}

	/**
	 * initialize the component
	 **/
	$onInit() {
		this.NavigationService.getUserModulRoutes('user').then(
			(response) => {
				this.navItems = response;
			}
		);
		this.currInstruction = this.$rootRouter.currentInstruction;

		this.$rootRouter.subscribe((url) => {
			this.routeEndpointInstruction = this.NavigationService.getRouteEndpointInstruction(this.$rootRouter.currentInstruction);
		});

		this.routeEndpointInstruction = this.NavigationService.getRouteEndpointInstruction(this.currInstruction);
	}

	/**
	 * check if component is active
	 **/
	isActive(component) {
		return this.NavigationService.isActiveRoute(component);
	}

	/**
	 * check if component has a parent
	 **/
	isParent(component) {
		return this.NavigationService.isParentRoute(component);
	}

}
